import React from 'react';
import styled from 'styled-components';

// Shopping bag with a trend line in its bottom-right corner, from the Agentic Commerce designs.
// Not in FontAwesome, so it is drawn inline and filled with currentColor like the FontAwesome nav icons.
const StyledSvg = styled.svg`
  height: 16px;
  width: 16px;
`;

export default function ShoppingBagChart() {
  return (
    <StyledSvg fill="currentColor" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 10.9599L15.537 11.4412L11.8331 15.2921L11.3701 15.7735L10.9072 15.2921L8.75563 13.0552L6.38623 15.5186L5.92325 16L5 15.0401L5.46299 14.5588L8.29537 11.614L8.75836 11.1326L11.3729 13.8509L14.6138 10.4814L15.0768 10L16 10.9599Z" />
      <path d="M7 0C8.93437 6.43231e-08 10.5 1.56563 10.5 3.5V5H12.5C13.3281 5 14 5.67188 14 6.5V9.5H12.5V6.5H10.5V8.25C10.5 8.66562 10.1656 9 9.75 9C9.33438 9 9 8.66562 9 8.25V6.5H5V8.25C5 8.66562 4.66563 9 4.25 9C3.83438 9 3.5 8.66562 3.5 8.25V6.5H1.5V13C1.5 13.8281 2.17188 14.5 3 14.5H4V16H3C1.34375 16 0 14.6562 0 13V6.5C1.93434e-07 5.67188 0.671875 5 1.5 5H3.5V3.5C3.5 1.56562 5.06563 0 7 0ZM7 1.5C5.89687 1.5 5 2.39687 5 3.5V5H9V3.5C9 2.39688 8.10312 1.5 7 1.5Z" />
    </StyledSvg>
  );
}
